import { useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import { BsChevronDown } from 'react-icons/bs';

import '../styles/langSwitcher.scss';
import { languageNames } from '../../utilities/constants/langConstants';
import { StyledNavButton } from '../styles/navStyles';

interface LanguageSwitcherButtonProps {
	currentLanguage?: string;
	onLanguageChange: (langCode: string) => void;
	supportedLanguages?: string[];
}

const LanguageSwitcherButton = ({ 
	currentLanguage = 'en', 
	onLanguageChange, 
	supportedLanguages = [] 
}: LanguageSwitcherButtonProps) => {
	const [showDropdown, setShowDropdown] = useState(false);

	const handleLanguageSelect = (langCode) => {
		onLanguageChange(langCode);
		setShowDropdown(false);
	};

	// Get display code for button (shortened version)
	const getDisplayCode = (langCode) => {
		// Extract base language code (before hyphen if present) and uppercase
		return langCode.slice(0, 2).toUpperCase();
	};

	if (!supportedLanguages || supportedLanguages.length === 0) {
		return null;
	}

	return (
		<Dropdown
			align="end"
			className="language-switcher-dropdown"
			show={showDropdown}
			onToggle={(isOpen) => setShowDropdown(isOpen)}
		>
			<Dropdown.Toggle
				as={StyledNavButton}
				className="desktop-menu-icons me-0 d-flex align-items-center w-100 language-switcher-toggle"
			>
				<div className="d-flex align-items-center justify-content-between w-100">
					<span className="ms-1">
						{languageNames[currentLanguage] || currentLanguage}
					</span>
					<BsChevronDown size={16} />
				</div>
			</Dropdown.Toggle>

			<Dropdown.Menu key={currentLanguage} className="shadow-sm w-100">
				{supportedLanguages.map((langCode) => (
					<Dropdown.Item
						key={langCode}
						active={currentLanguage === langCode}
						className="d-flex align-items-center"
						onClick={() => handleLanguageSelect(langCode)}
					>
						<span className="text-uppercase fw-bold me-4">
							{getDisplayCode(langCode)}
						</span>
						<span>{languageNames[langCode] || langCode}</span>
					</Dropdown.Item>
				))}
			</Dropdown.Menu>
		</Dropdown>
	);
};

export default LanguageSwitcherButton;
